import { useIsReadOnly } from '@/lib/casl'
import { cn } from '@/lib/utils'
import type { UniqueIdentifier } from '@dnd-kit/core'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Grip } from 'lucide-react'
import type { ReactNode } from 'react'

export type SortableListItemProps = {
  id: UniqueIdentifier
  children?: ReactNode
  className?: string
}

const SortableListItem = ({ id, children, className }: SortableListItemProps) => {
  const { isReadOnly } = useIsReadOnly()

  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id,
    disabled: isReadOnly,
  })
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }
  return (
    <li
      ref={setNodeRef}
      style={style}
      {...attributes}
      className={cn('inline-flex items-center w-full', className)}
    >
      {!isReadOnly && (
        <Grip
          className="h-4 w-4 cursor-grab active:cursor-grabbing touch-none"
          {...listeners}
          style={{ transition }}
        />
      )}
      {children}
    </li>
  )
}

export default SortableListItem
